import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "features-section" }
const _hoisted_2 = { class: "features-grid" }
const _hoisted_3 = { class: "features-column" }
const _hoisted_4 = { class: "feature-item" }
const _hoisted_5 = { class: "feature-info" }
const _hoisted_6 = { class: "feature-item" }
const _hoisted_7 = { class: "feature-info" }
const _hoisted_8 = { class: "feature-item" }
const _hoisted_9 = { class: "feature-info" }
const _hoisted_10 = { class: "features-column" }
const _hoisted_11 = { class: "feature-item" }
const _hoisted_12 = { class: "feature-info" }
const _hoisted_13 = { class: "feature-item" }
const _hoisted_14 = { class: "feature-info" }
const _hoisted_15 = { class: "feature-item" }
const _hoisted_16 = { class: "feature-info" }

import { computed, ref, watch } from 'vue'
import {
  User,
  Setting,
  WindPower,
  Location as LocationIcon,
  Remove as RemoveIcon,
  Operation as CarIcon,
} from '@element-plus/icons-vue'

import {
  EvCarProfileFull,
  EvCarProfileUpdateableKeys,
} from '@/models/evCarProfile'
import { useEvCarsStore } from '@/store/ev-vehicles'
import { RbacAction, RbacEntity } from '@/helpers/rbac'
import useScopeCheck from '@/composables/useScopeCheck'


export default /*@__PURE__*/_defineComponent({
  __name: 'EVFeaturesSection',
  props: {
    vehicle: {}
  },
  setup(__props: any) {

const props = __props

const evCarsStore = useEvCarsStore()

// Permissions
const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.CARS)

// Loading states
const updatingModule = computed(
  () => evCarsStore.evCarsDetails[props.vehicle.id]?.updating
)
const loadingKeys = computed(() => updatingModule.value?.loadingKeys || [])

// Features state
const features = ref({
  doors: false,
  seats: false,
  air_conditioner: false,
  automatic: false,
  no_smoking: false,
  gps: false,
})

// Watch for vehicle changes to update features
watch(
  () => props.vehicle,
  newVehicle => {
    if (newVehicle) {
      features.value = {
        doors: newVehicle.doors === 4,
        seats: newVehicle.seats === 4,
        air_conditioner: newVehicle.features?.air_conditioner ?? false,
        automatic: newVehicle.transmission === 'automatic',
        no_smoking: newVehicle.no_smoking ?? false,
        gps: newVehicle.features?.gps ?? false,
      }
    }
  },
  { immediate: true }
)

// Methods
const handleFeatureChange = async (key: string, value: any) => {
  try {
    if (key === 'doors') {
      await evCarsStore.updateEvVehicle(props.vehicle.id, {
        doors: value ? 4 : 2,
      })
    } else if (key === 'seats') {
      await evCarsStore.updateEvVehicle(props.vehicle.id, {
        seats: value ? 4 : 2,
      })
    } else if (key === 'transmission') {
      await evCarsStore.updateEvVehicle(props.vehicle.id, {
        transmission: value,
      })
    } else if (key === 'no_smoking') {
      // Update no_smoking field directly on vehicle
      await evCarsStore.updateEvVehicle(props.vehicle.id, {
        [key]: value,
      } as any)
    } else if (key === 'features') {
      await evCarsStore.updateEvVehicle(props.vehicle.id, { features: value })
    } else if (key === 'air_conditioner' || key === 'gps') {
      // Update features object
      const updatedFeatures = {
        ...props.vehicle.features,
        [key]: value,
      }
      await evCarsStore.updateEvVehicle(props.vehicle.id, {
        features: updatedFeatures as any,
      })
    }
  } catch (error) {
    console.error(`Failed to update ${key}:`, error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "section-title" }, "FEATURES", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, { class: "feature-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(CarIcon))
              ]),
              _: 1
            }),
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "feature-label" }, "4 Doors", -1))
          ]),
          _createVNode(_component_el_switch, {
            modelValue: features.value.doors,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((features.value.doors) = $event)),
            disabled: !_unref(allowedEditing),
            loading: loadingKeys.value.includes('doors'),
            onChange: _cache[1] || (_cache[1] = (val) => handleFeatureChange('doors', val))
          }, null, 8, ["modelValue", "disabled", "loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_icon, { class: "feature-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(User))
              ]),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "feature-label" }, "4 x Seats", -1))
          ]),
          _createVNode(_component_el_switch, {
            modelValue: features.value.seats,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((features.value.seats) = $event)),
            disabled: !_unref(allowedEditing),
            loading: loadingKeys.value.includes('seats'),
            onChange: _cache[3] || (_cache[3] = (val) => handleFeatureChange('seats', val))
          }, null, 8, ["modelValue", "disabled", "loading"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_icon, { class: "feature-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(WindPower))
              ]),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "feature-label" }, "Air Conditioner", -1))
          ]),
          _createVNode(_component_el_switch, {
            modelValue: features.value.air_conditioner,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((features.value.air_conditioner) = $event)),
            disabled: !_unref(allowedEditing),
            loading: loadingKeys.value.includes('features'),
            onChange: _cache[5] || (_cache[5] = (val) => handleFeatureChange('air_conditioner', val))
          }, null, 8, ["modelValue", "disabled", "loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_icon, { class: "feature-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Setting))
              ]),
              _: 1
            }),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "feature-label" }, "Automatic", -1))
          ]),
          _createVNode(_component_el_switch, {
            modelValue: features.value.automatic,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((features.value.automatic) = $event)),
            disabled: !_unref(allowedEditing),
            loading: loadingKeys.value.includes('transmission'),
            onChange: _cache[7] || (_cache[7] = (val) => handleFeatureChange('transmission', val ? 'automatic' : 'manual'))
          }, null, 8, ["modelValue", "disabled", "loading"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_icon, { class: "feature-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(RemoveIcon))
              ]),
              _: 1
            }),
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "feature-label" }, "No Smoking", -1))
          ]),
          _createVNode(_component_el_switch, {
            modelValue: features.value.no_smoking,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((features.value.no_smoking) = $event)),
            disabled: !_unref(allowedEditing),
            loading: false,
            onChange: _cache[9] || (_cache[9] = (val) => handleFeatureChange('no_smoking', val))
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_icon, { class: "feature-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(LocationIcon))
              ]),
              _: 1
            }),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "feature-label" }, "GPS", -1))
          ]),
          _createVNode(_component_el_switch, {
            modelValue: features.value.gps,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((features.value.gps) = $event)),
            disabled: !_unref(allowedEditing),
            loading: loadingKeys.value.includes('features'),
            onChange: _cache[11] || (_cache[11] = (val) => handleFeatureChange('features', { ..._ctx.vehicle.features, gps: val }))
          }, null, 8, ["modelValue", "disabled", "loading"])
        ])
      ])
    ])
  ]))
}
}

})